import React from "react";
import { shallowEqual } from "react-redux";
import { useUscDispatch, useUscSelector } from "../../../redux/store";
import { getMobileFooterCta } from "../../../utils/ctaUtils";
import { showModal } from "../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_USC_BASKET_DETAILS, MODAL_USC_DISCOVER_YOUR_CAR } from "../../../utils/modalConstants";
import { UscLabel } from "../../../utils/labels";
import useNavParams from "../../../hooks/useNavParams";
import * as Styles from "./MobileFooter.styles";
import Button from "../../../../shared-components/toyota/styles/atoms/Button";
import Text from "../../../../shared-components/toyota/styles/atoms/Text";
import Icon from "../../../../shared-components/toyota/styles/atoms/Icon";
import {
    trackDiscoverYourCarModalOpen,
    trackOpenBasketDetailsModal,
    UscTrackingLocation,
} from "../../../utils/tracking";
import { getToyotaButtonVariant } from "../../../utils/pdpUtils";
import { getBasketItemsCountSelector } from "../../../utils/basketUtils";

const MobileFooter = (): JSX.Element => {
    const dispatch = useUscDispatch();

    const commonSettings = useUscSelector((state) => state.commonSettings);
    const vehicleType = useUscSelector((state) => state.vehicle.type);
    const navParams = useNavParams(UscTrackingLocation.Footer);

    const mobileFooterCta = getMobileFooterCta(navParams);

    const basketItemsCount = useUscSelector(getBasketItemsCountSelector, shallowEqual);

    return (
        <Styles.Wrapper>
            <Styles.Body>
                {mobileFooterCta && (
                    <Button
                        variant={getToyotaButtonVariant(navParams.context, commonSettings.query.blackPrimaryCtas)}
                        size="fullwidth"
                        rounded
                        href={mobileFooterCta.href ? mobileFooterCta.href : undefined}
                        onClick={mobileFooterCta.onClick}
                        rel={mobileFooterCta.rel}
                    >
                        {mobileFooterCta.label}
                    </Button>
                )}
            </Styles.Body>

            <Styles.SecondaryCtas>
                <ul role="list">
                    {!!basketItemsCount && (
                        <li>
                            <Styles.SecondaryCta
                                type="button"
                                onClick={() => {
                                    trackOpenBasketDetailsModal(UscTrackingLocation.Footer, vehicleType);
                                    dispatch(showModal({ type: MODAL_USC_BASKET_DETAILS }));
                                }}
                            >
                                <span>
                                    <Icon variant="basket-variant" />
                                    <Text variant="body-small-regular">
                                        <UscLabel label="uscBasketCtaBasketDetails" />
                                    </Text>
                                </span>
                                <Styles.Badge>
                                    <Text variant="body-small-book" color="primary-white">
                                        {basketItemsCount}
                                    </Text>
                                </Styles.Badge>
                            </Styles.SecondaryCta>
                        </li>
                    )}
                    <li>
                        <Styles.SecondaryCta
                            type="button"
                            onClick={() => {
                                dispatch(showModal({ type: MODAL_USC_DISCOVER_YOUR_CAR }));
                                trackDiscoverYourCarModalOpen(vehicleType);
                            }}
                        >
                            <span>
                                <Icon variant="car" />
                                <Text variant="body-small-regular">
                                    <UscLabel label="uscDiscoverYourCar" />
                                </Text>
                            </span>
                            <Icon variant="chevron-up" />
                        </Styles.SecondaryCta>
                    </li>
                </ul>
            </Styles.SecondaryCtas>
        </Styles.Wrapper>
    );
};

export default MobileFooter;
